<template>
  <PageHeader :title="title">
    <template #top>
      <EngageWorkspaceTabs />
    </template>
  </PageHeader>
</template>

<script>
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import EngageWorkspaceTabs from './EngageWorkspaceTabs.vue';

export default {
  name: 'EngageWorkspaceHeader',
  components: {
    PageHeader,
    EngageWorkspaceTabs,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
